import React, { FC } from "react"
import { routePaths } from "../../../Routes"
import { Link } from "resha"

interface AppDetailLinkProps {
    className?: string
    orgUsername: string
    appID?: string
}

export const AppDetailLink: FC<AppDetailLinkProps> = ({
    orgUsername,
    className,
    appID
}) => {
    return appID ? (
        <div className={className}>
            Or{" "}
            <Link to={routePaths.appWelcome(orgUsername, appID)}>
                skip to the dashboard
            </Link>
        </div>
    ) : null
}
